import DialogWrapper2 from '../../../core/dialog/dialog_wrapper_v2';
import { FahrzeugeDetail } from './FahrzeugeDetail';
import { IDs } from '../../../helpers/IDs';
import { isValid } from '../../../main/functions/validData';
import { lazyInject } from '../../../services/inversify';
import * as React from 'react';
import { TriggerService } from '../../../core/trigger/trigger_service';
import { validateFieldUniversal } from '../functions/validateField';
import { WActionButton } from '../../../core/elements/WActionButton';
import { WFormsTableWrapper } from '../../../core/table/WFormsTableWrapper';
import { ZusatztoolsImport } from '../../zusatztools/ZusatztoolsImport';
import { getCustomFormConfig } from '../co2_custom/getCustomFormConfig';

export interface StandorteFahrzeugeProps {
    data: any;
    onRoutingChange: (routing: any) => void;
    routing: any;
    standortSelected: any;
}

export interface StandorteFahrzeugeState {
    hiddenFormFields: Array<any>;
    rowForDialog: any;
    showImportTool: boolean;
    validRestriction: string;
}

export class StandorteFahrzeuge extends React.Component<StandorteFahrzeugeProps, StandorteFahrzeugeState> {

    constructor(props: any) {
        super(props);
        this.state = {
            hiddenFormFields: [],
            rowForDialog: undefined,
            showImportTool: false,
            validRestriction: null
        };
        this.onAfterClose = this.onAfterClose.bind(this);
        this.preFilter = this.preFilter.bind(this);
        this.validateField = this.validateField.bind(this);
        this.customFormConfigFunc = this.customFormConfigFunc.bind(this);
    }

    @lazyInject(TriggerService) private triggerService: TriggerService;

    customFormatter(field: string, value: any, data: any, row: any): any {
        if ((+((row || {}).original || {}).status || null) === 2) {
            return <span style={{ color: '#aaa' }}>{value}</span>;
        }
        return value;
    }

    onAfterClose(): void {
        this.setState({ rowForDialog: undefined });
    }

    preFilter(data: Array<any>): any {
        const { standortSelected } = this.props;
        return standortSelected
            ? data.filter((item: any) => (+item.standort_tid_orig || null) === standortSelected.tid)
            : data;
    }

    render(): JSX.Element {
        const standort_tid: number = (this.props.standortSelected || {}).tid || null;
        return (
            <div>
                {!this.state.showImportTool &&
                    <WFormsTableWrapper
                        entity={IDs.ENT_FAHRZEUGE}
                        module={IDs.MOD_ETOOL}
                        actions={['add', 'edit', 'delete']}
                        customClass='Custom-ETA'
                        formLayout='flowV2'
                        addLabel='Fahrzeug erfassen'
                        formPreset={{ ...(standort_tid !== null ? { standort_tid: standort_tid } : {}) }}
                        hiddenFormFields={this.state.hiddenFormFields}
                        customFormConfig={getCustomFormConfig(IDs.ENT_FAHRZEUGE, this.state.rowForDialog, this.props.data)}
                        customFormConfigFunc={this.customFormConfigFunc}
                        customFormatter={this.customFormatter}
                        externalHeaderElements={[this.renderImportButton()]}
                        preFilterFunction={this.preFilter}
                        validateField={this.validateField}
                        validRestriction={this.state.validRestriction}
                        callBeforeOnFormSave={(data: any, callback: () => void) =>
                            this.setState(
                                { validRestriction: !isValid(data || {}, IDs.ENT_FAHRZEUGE, null, true) ? 'stop' : null },
                                () => callback()
                            )
                        }
                        onSaveDone={() => this.triggerService.fire('reload', IDs.ENT_FAHRZEUGE)}
                        onDelDone={() => this.triggerService.fire('reload', IDs.ENT_FAHRZEUGE)}
                    />
                }
                {this.state.rowForDialog &&
                    <DialogWrapper2
                        onAfterClose={this.onAfterClose}
                    >
                        <FahrzeugeDetail
                            data={this.props.data}
                            fahrzeugSelected={this.state.rowForDialog}
                        />
                        <div style={{ textAlign: 'right', marginRight: 4 }}>
                            {this.renderCloseButton()}
                        </div>
                    </DialogWrapper2>
                }
                {this.state.showImportTool && this.renderImport()}
            </div>
        );
    }

    renderCloseButton(): JSX.Element {
        return (
            <WActionButton
                label='Schließen'
                insideText='Schließen'
                key='close'
                action='delete'
                onAction={this.onAfterClose}
            />
        );
    }

    renderImport(): JSX.Element {
        return (
            <>
                <WActionButton
                    label='Import abbrechen'
                    insideText='Import abbrechen'
                    key='cancel'
                    action='cancel'
                    onAction={() => this.setState({ showImportTool: false })}
                />
                <ZusatztoolsImport
                    data={this.props.data}
                    modul={IDs.MOD_ETOOL}
                    IDs={IDs}
                    entity={IDs.ENT_FAHRZEUGE}
                    onFinish={() => this.setState(
                        { showImportTool: false },
                        () => this.triggerService.fire('reload', IDs.ENT_FAHRZEUGE)
                    )}
                    standort={this.props.standortSelected}
                    whitelistStructures={[IDs.ENT_FAHRZEUGE]}
                />
            </>
        );
    }

    renderImportButton(): JSX.Element {
        return (
            <WActionButton
                label='Import'
                insideText='Import'
                tooltip='Import aus Excel'
                key='import'
                action='import'
                onAction={() => this.setState({ showImportTool: true })}
            />
        );
    }

    validateField(key: string, value: any, data: any, onValueChange: (name: string, value: any) => void): string {
        if (key === 'status') {
            this.setState({ hiddenFormFields: +value !== 2 ? ['jahr_status'] : [] });
        }
        return validateFieldUniversal(IDs.ENT_FAHRZEUGE, key, value, data, onValueChange);
    }

    customFormConfigFunc(formConfig: any, formData: any) {
        if (formConfig && formConfig.items && formData && formData.values) {
            const { standortSelected } = this.props;
            const standortConfigIdx = (formConfig.items || []).findIndex((c: any) => c.key === 'standort_tid');
            if (standortConfigIdx >= 0) {
                formConfig.items[standortConfigIdx].readonly = false;
                if ((standortSelected && standortSelected.tid > 0) || formData.values.standort_tid > 0) {
                    formConfig.items[standortConfigIdx].readonly = true;
                }
            }
        }
    }
}
